import React from "react";
import { IconButton, TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CommonTable, { HeadCell } from "../../../../../business-types/grocery/components/CommonTable";
import ViewListIcon from "@mui/icons-material/ViewList";
import { CarOrderTableProps } from "../utils/types";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";

// Define a local interface for the table row data
interface TableRowData {
  id: string | number;
  SNo: number;
  CustomerName: string;
  CustomerPhoneNo: string;
  Orderid: string;
  OrderStatus: string;
  Actions: React.ReactNode;
}

const CarOrderTable: React.FC<CarOrderTableProps> = ({
  orders,
  onRowClick,
  page,
  rowsPerPage,
  paginationData,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const navigate = useNavigate();

  const handleCustomerClick = (orderId: string | number) => {
    if (onRowClick) {
      onRowClick(orderId);
    } else {
      navigate(`/v1/car-order-details/${orderId}`);
    }
  };

  const headCells: HeadCell<TableRowData>[] = [
    { id: "SNo", label: "S.No" },
    { id: "CustomerName", label: "Name" },
    { id: "CustomerPhoneNo", label: "Phone Number" },
    { id: "Orderid", label: "Order ID" },
    { id: "OrderStatus", label: "Order Status" },
    { id: "Actions", label: "Actions" },
  ];

  // Transform the orders data to match the table structure
  const tableData: TableRowData[] = orders.map((order, index) => {
    // Extract customer name and phone number from order data
    const customerName = order.customerDetails 
      ? `${order.customerDetails.firstName || ''} ${order.customerDetails.middleName || ''} ${order.customerDetails.lastName || ''}`.trim()
      : 'N/A';
    
    const phoneNumber = order.customerDetails?.phones?.[0]?.phone || 'N/A';
    
    // Get order status from the first transaction or use default
    const orderStatus = order.orders?.[0]?.status || 'Unknown';

    return {
      id: order.orderId || index, // Use orderId as unique ID
      SNo: index + 1,
      CustomerName: customerName,
      CustomerPhoneNo: phoneNumber,
      Orderid: order.orderId || 'N/A',
      OrderStatus: orderStatus,
      Actions: (
        <IconButton 
          size="small" 
          onClick={() => handleCustomerClick(order.orderId || index)}
        >
          <ViewListIcon sx={{ color: "black" }} />
        </IconButton>
      ),
    };
  });

  return (
    <div className="thin-scrollbar w-full h-[72vh] overflow-y-auto">
      <CommonTable
        data={tableData}
        headCells={headCells}
        title=""
        pagenation={false}
        denseToggle={false}
        className="w-full"
        selectable={false}
      />

      {/* Pagination */}
      <div className="flex justify-end mr-8 mt-2">
        <TablePagination
          component="div"
          count={paginationData?.totalRecords || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        />
      </div>
    </div>
  );
};

export default CarOrderTable;
